"use client";

import { Package, TrendingUp, Headphones } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FeatureIcons() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2,
    once: true
  });
  const features = [{
    icon: Package,
    label: "Packet Management",
    ref: ref1,
    isVisible: isVisible1
  }, {
    icon: TrendingUp,
    label: "Rate Negotiation",
    ref: ref2,
    isVisible: isVisible2
  }, {
    icon: Headphones,
    label: "24/7 Support",
    ref: ref3,
    isVisible: isVisible3
  }];
  return <section className="bg-background py-16">
      <div className="mx-auto max-w-screen-xl px-4">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} ref={feature.ref} className={`flex flex-col items-center text-center transition-all duration-150 ease-out ${feature.isVisible ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"}`} style={{
            transitionDelay: `${i * 80}ms`
          }}>
                <Icon className="mb-4 h-20 w-20 text-muted-dark transition-transform duration-medium ease-[var(--ease-out-back)] hover:scale-103" strokeWidth={1.5} />
                <p className="text-foreground font-medium">{feature.label}</p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}